<template>
    <div style="position: relative">
        <a-button  @click="backs" class="backbtn"  key="7" tab=""> 返回  </a-button>
        <a-tabs default-active-key="1"  >
        <a-tab-pane key="1" tab="信息总览">
            <WebDetails/>
        </a-tab-pane>
        <a-tab-pane key="2" tab="流量统计" >
            <Flow/>
        </a-tab-pane>
        <a-tab-pane key="3" tab="访客来源">
            <SourceVisitors/>
        </a-tab-pane>
        <a-tab-pane key="4" tab="地域分布">
            <Maps/>
        </a-tab-pane>
        <a-tab-pane key="5" tab="询盘统计">
            <Inquiry/>
        </a-tab-pane>
        <a-tab-pane key="6" tab="关键词">
            <KeyWord/>
        </a-tab-pane>
    </a-tabs>

    </div>
</template>

<script>
    import WebDetails from "./components/webDetails"
    import Flow from "./components/flow"
    import SourceVisitors from "./components/sourceVisitors"
    import Maps from "./components/maps"
    import Inquiry from "./components/inquiry"
    import KeyWord from "./components/keyWord"
    export default {
        name: "index",
        data(){
            return{

            }
        },
        methods:{backs(){
                this.$router.push({path: '/DataStatistics/WebStatistics'})
            }},
        components:{WebDetails,Flow,SourceVisitors,Maps,Inquiry,KeyWord}
    }
</script>

<style scoped>
.backbtn{position: absolute;right: 0;z-index: 9999999;top:5px}
</style>
